module.exports = __webpack_public_path__ + "static/img/img01.d0b931f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/en018/img01.jpg
// module id = XFV5
// module chunks = 0